import { Td, Flex } from "@chakra-ui/react";
import { SquarePenIcon, TrashIcon } from "lucide-react";

interface RowActionsProps {
  item: any;
  onEdit: (i: any) => void;
  onDelete: (i: any) => void;
  showEdit: boolean;
  showDelete: boolean;
  disableDelete: boolean;
}

const RowActions = ({
  item,
  onEdit,
  onDelete,
  showEdit,
  showDelete,
  disableDelete,
}: RowActionsProps) => {
  const handleEdit = () => {
    onEdit(item);
  };

  return (
    <Td width="120px">
      <Flex gap={2}>
        {showEdit && (
          <SquarePenIcon
            size="20px"
            color="#71717A"
            cursor="pointer"
            onClick={handleEdit}
          />
        )}
        {showDelete && (
          <TrashIcon
            size="20px"
            color="#71717A"
            cursor="pointer"
            onClick={() => onDelete(item)}
            style={{
              pointerEvents: disableDelete ? "none" : "auto",
              opacity: disableDelete ? 0.5 : 1,
            }}
          />
        )}
      </Flex>
    </Td>
  );
};

export default RowActions;
